export default "__VITE_ASSET__Bs3l8pNE__"